module.exports = __webpack_public_path__ + "static/media/scenic-landscape.6a7126e8.jpeg";